export class CustomerIdentification {
    public id: number;
    public customerNumberId: number;
    public customerIdentificationTypeId: number;
    public customerIdentificationValue: string;
    public locationCode: string;
    public effectiveDate: any;
    public endDate: any;
    public updatedBy: string;
    public updatedDate: any;
    public viewId: number;
    public identificationType: string;
    public allowEdit: boolean;
}
